module.exports = __webpack_public_path__ + "img/apoio-biobridge.2413c59f.png";